angular.module('unergie.main')
.directive('userInfoContractHistory', (DataAccess, AlertManager, ErrorCatcher) =>
    ({
        restrict: 'E',
        templateUrl: '/states/userContractInfo/component/contract/userInfoContractHistory.html',
        link($scope) {
            $scope.contractMods = {}

            $scope.fieldConf = {
                max_power: { name: 'Puissance', class: 'red' },
                id_p_calendar: { name: 'Tarif', class: 'green' },
                provider_offer: { name: 'Offre', class: 'orange' },
            }

            $scope.refresh = () => {
                $scope.refreshing = true
                return DataAccess.getContractHistory({ id_contract: $scope.contract.id }).$promise
                .then((historics) => {
                    $scope.historics = historics
                    // check modifs OT/PS
                    if (_.uniq(_.compact(_.map(historics.id_p_calendar, 'value'))).length > 1) { // le contrat a connu plusieurs id_p_calendar non nulls
                        // on détermine s'il y a eu modification d'OT dans l'année
                        $scope.contract.modifOTInYear = moment(historics.id_p_calendar[0].start_date).isAfter(moment().add(-1, 'year'))
                    }
                    if (_.uniq(_.compact(_.map(historics.max_power, 'value'))).length > 1) { // le contrat a connu plusieurs max_power non nulls
                        // on détermine s'il y a eu modification de PS à la baisse dans l'année
                        $scope.contract.downGradePSInYear = historics.max_power[0].value < historics.max_power[1].value &&
                            moment(historics.max_power[0].start_date).isAfter(moment().add(-1, 'year'))
                    }
                })
                .catch(ErrorCatcher)
                .finally(() => {
                    $scope.refreshing = false
                })
            }

            $scope.refresh()
        },
    })
)
